const LINKS = [
  { href: "/#about", label: "Обо мне" },
  { href: "/#skills", label: "Навыки" },
  { href: "/#portfolio", label: "Портфолио" },
  { href: "/#contacts", label: "Контакты" },
];

export default LINKS;